import React from "react";
import { ImagePlus, Quote } from "lucide-react";
import { useSite } from "../lib/SiteContext";

const PLACEHOLDERS = [
  { name: "Story #1", quote_hint: "A family we helped — story to be added here." },
  { name: "Story #2", quote_hint: "A volunteer's why — story to be added here." },
  { name: "Story #3", quote_hint: "A child's first clean shirt — story to be added here." },
];

function StoryCard({ story, isPlaceholder, idx }) {
  return (
    <article
      data-testid={`story-card-${idx}`}
      className="group rounded-3xl overflow-hidden bg-[#27221F] border border-dashed border-[#3A3431] hover:border-[#EBB04D]/60 transition-colors"
    >
      <div className="relative h-56 overflow-hidden bg-[#1C1917] flex flex-col items-center justify-center text-[#57534E]">
        {story?.image_url ? (
          <img
            src={story.image_url}
            alt={story.name || "Story"}
            className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        ) : (
          <>
            <ImagePlus className="h-10 w-10" strokeWidth={1.5} />
            <span className="mt-3 text-xs uppercase tracking-[0.16em] font-semibold">
              Photo coming soon
            </span>
          </>
        )}
        {story?.image_url && (
          <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917] via-transparent to-transparent" />
        )}
      </div>
      <div className="p-7 md:p-8 relative">
        <Quote className="h-6 w-6 text-[#D85C41]/60" strokeWidth={1.5} />
        <p
          className={`mt-3 font-display text-lg md:text-xl leading-snug ${
            isPlaceholder ? "italic text-[#A8A29E]" : "text-[#F9F7F4]"
          }`}
        >
          {isPlaceholder ? story.quote_hint : `"${story.quote}"`}
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[0.16em] text-[#EBB04D]">
          {story.name || "Untitled"}
        </p>
      </div>
    </article>
  );
}

export default function Stories() {
  const { config } = useSite();
  const stories = (config.stories || []).filter(Boolean);
  const showPlaceholders = stories.length === 0;
  const items = showPlaceholders ? PLACEHOLDERS : stories;

  return (
    <section
      id="stories"
      data-testid="stories-section"
      className="bg-[#1C1917] text-[#F9F7F4] py-20 md:py-28 relative overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#EBB04D]">
            Stories from the wash
          </span>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-bold leading-[1.05]">
            The reason we're still here.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#A8A29E]">
            Real stories from real Hamilton families and volunteers — coming
            soon. With permission, we'll share the moments that remind us why
            this work matters.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
          {items.map((s, i) => (
            <StoryCard
              key={s.id || i}
              story={s}
              isPlaceholder={showPlaceholders}
              idx={i}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
